(function () {
  try {
    var cookie = document.cookie.split(';')
    // Detect if the cookie banner is open or not. We do not want to
    // track users on Bugsnag if it is open.
    var isCookieBannerOpen = document.getElementById('cookie-consent-container')
      .getElementsByClassName( 'banner-content' ).length > 0;
    trackingPreferences = cookie.reduce(function (result, value) {
      var val = value.split('=');
      var key = val[0];
      var newResult = {};
      if (' tracking-preferences' === key) {
        newResult = JSON.parse(decodeURIComponent(val[1]));
      }
      return {...result, ...newResult};
    }, {});
    var isFunctionalPreference = ((trackingPreferences || {}).custom || {}).functional;
    if (!isCookieBannerOpen) {
      if (isFunctionalPreference || 0 === Object.keys(trackingPreferences).length) {
        if (Bugsnag) {
          Bugsnag.apiKey = 'b0c02ec3d6bfbe65686b19820b40835a';
          Bugsnag.appVersion = process.env.PEERSPACE_WEB_TEMPLATES_VERSION;
          Bugsnag.metaData = {
            isCookieBannerOpen: isCookieBannerOpen,
            isFunctionalPreference: isFunctionalPreference,
            hasTrackingCookie: !!Object.keys(trackingPreferences).length
          };
        }
      }
    }
  } catch (e) {
    console.log(e);
  }
})();
